import { Pipe, PipeTransform } from '@angular/core';
import { FileDto } from '@api-client';

@Pipe({
  name: 'dataUrl',
})
export class DataUrlPipe implements PipeTransform {
  transform(file: File | FileDto | string | null): string {
    if (!file) return '';
    if (typeof file === 'string') return file;
    if (typeof file === 'object' && 'url' in file) return file.url;
    return URL.createObjectURL(file);
  }
}
